import { render } from "./consultant_detail.vue?vue&type=template&id=2482d168"
import script from "./consultant_detail.vue?vue&type=script&lang=js"
export * from "./consultant_detail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__